import { Link } from 'react-router-dom';

interface HeroSlide {
  title: string;
  subtitle: string;
  description: string;
  image: string;
  cta: string;
  ctaLink: string;
}

export default function HeroSection({ slides }: { slides: HeroSlide[] }) {
  const slide = slides[0];

  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={slide.image}
          alt="开云电竞 - 专业电竞竞技平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 md:px-10">
        <p className="text-accent-400 text-sm md:text-base font-heading tracking-widest uppercase mb-4 animate-fadeIn">
          {slide.subtitle}
        </p>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white font-heading mb-6 tracking-tight">
          {slide.title}
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-2xl mb-8 leading-relaxed">
          {slide.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to={slide.ctaLink}
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            {slide.cta}
          </Link>
          <Link
            to="/category/all"
            className="px-8 py-3.5 border border-white/30 text-white rounded-md text-sm font-medium hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
          >
            浏览赛事
          </Link>
        </div>

        <div className="mt-12 md:mt-16 flex items-center gap-8 md:gap-12">
          {[
            { value: '200+', label: '覆盖赛事' },
            { value: '500万+', label: '注册用户' },
            { value: '99.9%', label: '数据准确率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white font-heading">
                {stat.value}
              </p>
              <p className="text-xs md:text-sm text-white/60 mt-1">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn { animation: fadeIn 0.8s ease-out; }
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(6px); }
        }
        .animate-bounce { animation: bounce 1.5s ease-in-out infinite; }
      `}</style>
    </section>
  );
}